import { Environment } from './environment.interface';

export const environment: Environment = {
  // API CONFIG
  API_CLIENT_URL:
    'https://24koacj6g3.execute-api.eu-central-1.amazonaws.com/mk/',

  // ADYEN CONFIG
  ADYEN_CLIENT_KEY: 'test_56X4WOB2INCDNHBNUTZCXDE7BERRONGH',
  ADYEN_ENVIRONMENT: 'test',

  // HEAP CONFIG
  HEAP_ID: '',
  STAGE: 'local',

  // ENVIRONMENT CONFIG
  production: false,
  runBackwardCompatibilityTests: false, // Disabled to prevent 404 errors in local development
};
